var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defer, EMPTY, merge, of, Subject } from 'rxjs';
import { catchError, map, retryWhen } from 'rxjs/operators';
import { ajax, AjaxError } from 'rxjs/ajax';
import { attachmentsUrl } from './consts';
import { validateAttachment } from '../utils/helpers/helpers';
import { addCsrfTokenHeader, getCsrfToken } from '../api/csrf';
import { getErrors } from '../api/exceptions';
export var uploadAttachment = function (file) {
    var errors = validateAttachment(file);
    if (Object.keys(errors).length) {
        return of({
            success: false,
            errors: errors,
        });
    }
    var formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('type', 'CV');
    formData.append('primary', 'true');
    var progressSubscriber = new Subject();
    var upload$ = ajax({
        url: attachmentsUrl,
        method: 'POST',
        headers: __assign(__assign({}, addCsrfTokenHeader(getCsrfToken())), { 'source-system': 'pro.registration-confirmation-success-modal' }),
        progressSubscriber: progressSubscriber,
        body: formData,
    }).pipe(map(function (res) {
        if (res.status <= 400)
            return res;
        throw res;
    }), retryWhen(function (err) {
        return err.pipe(map(function (res, i) {
            if (res.status === 403 && i < 1)
                return defer(function () { return res; });
            throw res;
        }));
    }), map(function () { return ({ success: true, errors: {} }); }), catchError(function (err) {
        if (err instanceof AjaxError &&
            err.status === 400 &&
            'ValidationErrors' in err.response) {
            return of({
                success: false,
                errors: getErrors(err.response.ValidationErrors),
            });
        }
        else {
            return of({ success: false, errors: {} });
        }
    }));
    return merge(progressSubscriber.pipe(catchError(function () { return EMPTY; })), upload$);
};
//# sourceMappingURL=api.js.map